module.exports = __webpack_public_path__ + "img/img15.89547856.png";